import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {repoAppBuilder} from '@github-ui/repo-app-builder'
import {workflowRunsMainQuery} from '../queries/workflow-runs/workflow-runs-query'

export function buildWorkflowRunsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('workflowRunsRoute', {
    path: '/:owner/:repo/actions/workflows/:workflowFileName/*',
    queries: [workflowRunsMainQuery],
  })
}

export const workflowRunsRoute = buildWorkflowRunsRoute(repoAppBuilder)
